import { Remittance, RemittanceItem } from "@/core/entities/deduction";

export const getRemittanceItemNetAmount = (
  remittanceItemId: number | null | undefined,
  remittanceItems: RemittanceItem[],
  remittances: Remittance[]
): number | null => {
  if (!remittanceItemId) {
    return null;
  }

  const remittanceItem = remittanceItems.find(item => item.remittanceItemId === remittanceItemId);
  let netAmount = remittanceItem?.netAmount ?? null;

  if (netAmount === null) {
    const remittance = remittances.find(r =>
      r.remittanceItems.some(item => item.remittanceItemId === remittanceItemId)
    );
    netAmount = remittance?.remittanceItems.find(item => item.remittanceItemId === remittanceItemId)?.netAmount ?? null;
  }

  if (netAmount === null || netAmount === undefined) {
    return null;
  }

  return Math.abs(Number(netAmount));
};
